import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-textbox',
  templateUrl: './textbox.component.html',
  styles: [
  ]
})
export class TextboxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
